export default {"src":"/_next/static/media/philips_logo.312be04e.svg","height":42,"width":108,"blurWidth":0,"blurHeight":0};